module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/triangle-fcf7d9312964268a93654e3d4fd748df.svg";